export default {
  common: {
    cancel: 'キャンセル',
    ok: 'OK',
    search: '検索',
    all: '全て',
    not_set: '未設定',
    save: '保存する',
    male: '男性',
    female: '女性',
    not_found: '表示するデータはありません。',
    delete: '削除',
    edit: '編集',
  },
  login: {
    title: '管理者ログイン',
    username: {
      label: 'ログインID',
      placeholder: 'メールアドレスを入力',
    },
    password: {
      label: 'パスワード',
      placeholder: 'パスワードを入力',
    },
    submit: 'ログイン',
  },
  setting: {
    logout: 'ログアウト',
    db: 'DB指定・管理',
    url: {
      label: 'URL',
      placeholder: 'URLを入力してください',
    },
    app_id: {
      label: 'APP ID',
      placeholder: 'APP IDを入力してください',
    },
    app_key: {
      label: 'APIキー',
      placeholder: 'APIキーを入力してください',
    },
    db_id: {
      label: 'DB ID',
      placeholder: 'DB IDを入力してください',
    },
    db_key: {
      label: 'DBキー',
      placeholder: 'DBキーを入力してください',
    },
    next: '次へ',
    private_db: {
      label: 'Private DB',
      placeholder: 'Private DBを選択してください',
      title: 'DB選択',
    },
    back: '戻る',
    finish: '完了',
    no_options: 'オプションなし',
  },
  side_bar: {
    user: 'ユーザー管理',
    database: 'DB選択',
    tag: 'タグ編集',
    db_setting: 'DB再設定',
  },
  home: {
    title: 'ユーザー一覧',
    dialog: {
      title_delete: 'ユーザの削除',
      content_delete: 'ユーザ（{{0}}）を削除します。よろしいでしょうか。',
      search: '検索',
      display_name: '名前',
      display_name_placeholder: '名前を入力してください',
      affiliation: '所属',
      affiliation_placeholder: '所属を入力してください',
      tag: 'タグ',
      tag_placeholder: 'タグを入力してください',
    },
  },
  user_add: {
    title: 'ユーザー新規追加',
    display_name: '名前',
    display_name_placeholder: '名前を入力してください',
    affiliation: '所属',
    affiliation_placeholder: '所属を入力してください',
    tag: 'タグ',
    tag_placeholder: 'タグを選択してください',
    gender: '性別',
    gender_placeholder: '性別を選択してください',
    age: '年齢',
    age_placeholder: '年齢を入力してください',
    group: 'グループ',
    group_placeholder: 'グループを入力してください',
    id_number: 'ID番号',
    id_number_placeholder: 'ID番号を入力してください',
    phone_number: '電話番号',
    phone_number_placeholder: '（例）08012345678 ※ハイフンなし',
    photo_register: '写真登録',
    avatar_image: '表示画像',
    ref_photo: '認証用写真',
    property: 'ユーザー情報',
  },
  user_detail: {
    title: 'ユーザー詳細',
  },
  tag: {
    title: 'タグ編集',
    tags: 'タグ',
    content: 'タグを入力してください',
    dialog_delete: {
      title: 'タグの削除',
      content: 'タグ（{{0}}）を削除します。よろしいでしょうか。',
    },
    dialog_add: {
      title: 'タグ追加の確認',
    },
    dialog_edit: {
      title: 'タグ情報の編集',
    },
    dialog_search: {
      title: '検索',
    },
  },
  setting_db: {
    placeholder: '設定画面に戻ります。よろしいでしょうか。',
  },
  user: {
    dialog_add: {
      title: 'ユーザ追加の確認',
      placeholder: 'ユーザを新規追加します。よろしいでしょうか？',
    },
    dialog_edit: {
      title: 'ユーザ情報の編集',
      placeholder: 'ユーザ情報を修正します。よろしいでしょうか。',
    },
  },
  message_error: {
    app_config:
      '入力された APP ID、APPキー、DB ID または DBキーが正しくありません。',
    max_age: '年齢が無効です。',
    max_length: '{{0}}は{{1}}文字以内で入力してください。',
    min_length: '{{0}}は{{1}}文字以上で入力してください。',
    range_phone: '電話番号は10桁または11桁で入力してください。',
    internal_server:
      'サーバーでエラーが発生しました。管理者に問い合わせてください。',
    file_upload_add: '{{0}}/{{1}}枚の画像は既に存在します。',
    file_upload_update: '{{0}}/{{1}}枚の画像が一致しません。',
    format_url: '正しい形式でURLを入力してください。',
    url_invalid: 'URLが有効ではありません。',
  },
};
